<template>
  <div id="pageContent">
    <div class="login-page">
      <ul>
        <li>
          <img src="@/assets/img/login_text.png" alt="">
          <p class="title">전남드래곤즈 아이디와 비밀번호를<span>입력하세요</span></p>
        </li>
        <li>
          <input type="text" class="input-style" v-model="login.id" placeholder="아이디">
        </li>
        <li class="pw-div">
          <input :type="!inputType ? 'password' : 'text'" id="password" v-model="login.pw"
                 class="input-style"  placeholder="비밀번호" @keyup.enter="loginFunc">
          <div class="eyes" @click="inputType = !inputType">
            <img :class="{off: !inputType}" :src="imageSrc(!inputType ? 'off' : 'on')" alt="">
          </div>
        </li>
        <li>
          <button class="login-btn" @click="loginFunc">로그인</button>
        </li>
        <li class="footer">
          <router-link :to="{name: 'join'}" class="join">회원가입</router-link>
          <div class="right">
            <router-link :to="{name: 'findId'}">아이디찾기</router-link>
            <router-link :to="{name: 'findPassword'}">비밀번호찾기</router-link>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import {replaceAllEmpty} from '@/lib';

export default {
  name: 'Login',
  data() {
    return {
      inputType: false,
      login : {
        id: '',
        pw: ''
      }
    }
  },
  mounted () {
    // 티켓예매에서 이동했을 경우 스크롤 이동
    const redirectUrl = this.$route.params.redirectUrl;
    if (redirectUrl === '/ticket/reservations') {
      this.$nextTick(() => {
        const loginPageElement = this.$el.querySelector('.login-page');
        if (loginPageElement) {
          const elementOffsetTop = loginPageElement.offsetTop;
          const elementHeight = loginPageElement.offsetHeight;
          const windowHeight = window.innerHeight;
          const scrollTo = elementOffsetTop + (elementHeight / 2) - (windowHeight / 2);
          window.scrollTo(0, scrollTo);
        }
      });
    }
  },
  methods: {
    imageSrc(imgSrc) {
      return require('@/assets/img/visibility_'+imgSrc+'.png');
    },
    async loginFunc() {
      if (replaceAllEmpty(this.login.id) === "" || replaceAllEmpty(this.login.pw) === "") {
        alert('아이디 또는 비밀번호를 입력해주세요.');
        return;
      }

      const data = {
        user_id: this.login.id,
        user_pw: this.login.pw
      };

      const loginRes = await this.$http.post('/account/login', data)
          .catch(err => {
            return false;
          })

      if(loginRes.data.success) {
        const data = loginRes.data.data;
        data.state = true;
        this.$store.commit('login', data);

        if(loginRes.data.change_pw) {
          alert(loginRes.data.message);
          // 회원정보 변경 페이지로 이동
          return this.$router.push({name: 'myInfo'});
        }

        const redirectUrl = this.$route.params.redirectUrl;
        if(redirectUrl) {
          await this.$router.push(redirectUrl);
        } else {
          await this.$router.push({name: 'main'});
        }
      } else {
        // 휴면계정
        alert(loginRes.data.message);
        // 휴면계정 페이지로 이동
        // return this.$router.push({name: 'mypage'});
      }

    }
  }
}
</script>
